import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import { isMetal, isRigid } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidRoulette = (values: EstimateValues, roulette?: string) => {
  switch (roulette) {
    case ESTIMATE_CONSTANT["ミシン目面付け 面付け数"].なし.value:
      return true

    case ESTIMATE_CONSTANT["ミシン目面付け 面付け数"]["2～5面付"].value:
    case ESTIMATE_CONSTANT["ミシン目面付け 面付け数"]["6～10面付"].value:
    case ESTIMATE_CONSTANT["ミシン目面付け 面付け数"]["11～15面付"].value:
    case ESTIMATE_CONSTANT["ミシン目面付け 面付け数"]["16～20面付"].value:
    case ESTIMATE_CONSTANT["ミシン目面付け 面付け数"]["21～25面付"].value:
    case ESTIMATE_CONSTANT["ミシン目面付け 面付け数"]["26～30面付"].value:
      return isRigid(values)

    case ESTIMATE_CONSTANT["ミシン目面付け 面付け数"].あり.value:
      return isMetal(values)

    default:
      return false
  }
}

export default isValidRoulette
